import AppCopy from "copy/AppCopy";
import { formatDate } from "functions/text";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "router/Paths";
import { CarRequestType } from "types/loadedData";

function CarRequestCard({ request }: { request: CarRequestType }) {
  const navigate = useNavigate();
  const { customerText, dateText } = AppCopy.reportsPage;

  const handleOnCustomerPress = () => {
    navigate(`${Paths.users}/${request.user?._id}`);
  };

  return (
    <div className={Classname.container}>
      <div className={Classname.customer} onClick={handleOnCustomerPress}>
        <span className={Classname.title}>{customerText}</span>
        <span>{request?.user?.name || "Unknown user"}</span>
      </div>
      <div className={Classname.model}>
        <span className={Classname.title}>Phone</span>
        <span>{request?.phone}</span>
      </div>
      <div className={Classname.model}>
        <span className={Classname.title}>Request type</span>
        <span>{request?.option || "Not specified"}</span>
      </div>
      <div className={Classname.model}>
        <span className={Classname.title}>Description</span>
        <p className="line-clamp-3 leading-5">{request?.description || "No description"}</p>
      </div>

      <div className={Classname.date}>
        <span className={Classname.title}>{dateText}</span>
        <span>{formatDate(request?.createdAt)}</span>
      </div>
    </div>
  );
}

export default CarRequestCard;

const Classname = {
  container:
    "flex w-full flex-shrink-0 flex-wrap items-start justify-between border-b border-slate-100 px-2 py-3 text-sm text-secondaryText hover:bg-slate-50 sm:flex-nowrap sm:items-center",
  carNo: "w-32 sm:w-1/6 my-2 sm:my-0 ",
  customer: "w-32 sm:w-1/6 text-blue cursor-pointer my-2 sm:my-0 ",
  model: "w-32 sm:w-1/6 text-primaryText my-2 sm:my-0 ",
  status: "w-32 sm:w-1/6 flex  my-2 sm:my-0 ",
  date: "w-32 text-xs sm:w-1/6 flex flex-col my-2 sm:my-0 ",
  detail: "w-32 sm:w-1/6 flex sm:justify-end my-2 sm:my-0 ",

  title: "flex sm:hidden my-2 text-xs text-secondaryText",

  carTag:
    "flex items-center justify-center w-20 bg-bgSecondary rounded-md text-primaryText",
  carTagBold: "font-bold",

  detailsButton: "bg-blue text-white p-1 rounded-md px-3",
};
